import { makeStyles } from "@mui/styles";
import { Theme } from "@mui/material/styles";

const useStyles = makeStyles((theme: Theme) => ({
  container: {
    width: "100%",
    display: "flex",
    flexDirection: "row-reverse",
    alignItems: "end",
    alignContent: "end",
    position: "relative",
    [theme.breakpoints.down("desktop")]: {
      flexDirection: "column",
      alignItems: "center",
      alignContent: "center",
    },
  },
  button: {
    [theme.breakpoints.down("desktop")]: {
      width: "100%",
      marginBottom: 30,
    },
  },
  textContainer: {
    padding: "0 16px",
    cursor: "pointer",
    [theme.breakpoints.down("desktop")]: {
      marginBottom: 30,
    },
  },
  text: {
    textDecoration: "underline",
  },
  backContainer: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    width: "61px",
    cursor: "pointer",
    position: "absolute",
    ...(theme.direction !== "rtl" ? { left: 0 } : { right: 0 }),

    bottom: 0,
    [theme.breakpoints.down("desktop")]: {
      position: "static",
      marginBottom: 35,
    },
  },

  img: {
    ...(theme.direction !== "rtl" ? { margin: "5px 10px 0 0" } : { margin: "5px 0 0 10px" }),
    // margin: '5px 10px 0 0',
  },

  title: {
    color: " #353535",
    fontSize: "16px",
    letterSpacing: 0,
  },
}));

export default useStyles;
